/*
 * Copyright (C) 2022 neocotic
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { AbstractWebDomParentNode } from "./AbstractWebDomParentNode";
const _root = Symbol();
const _tagName = Symbol();
/**
 * An implementation of {@link DomElement} for DOM elements within a web browser.
 */
export class WebDomElement extends AbstractWebDomParentNode {
    /**
     * Creates an instance of {@link WebDomElement} using the `options` provided.
     *
     * @param options - The options to be used.
     */
    constructor(options) {
        super(options);
        this[_root] = options.root;
        this[_tagName] = options.node.tagName.toUpperCase();
    }
    attr(name) {
        var _a;
        return (_a = this.node().getAttribute(name)) !== null && _a !== void 0 ? _a : undefined;
    }
    css(name) {
        if (!name) {
            return;
        }
        const { style } = this.node();
        return style[name] || undefined;
    }
    hasAttr(name) {
        return this.node().hasAttribute(name);
    }
    innerHtml() {
        return this.node().innerHTML;
    }
    isElement() {
        return true;
    }
    outerHtml() {
        return this.node().outerHTML;
    }
    prop(name) {
        const node = this.node();
        if (!(name in node)) {
            return;
        }
        const value = node[name];
        return value != null ? value : undefined;
    }
    root() {
        return this[_root];
    }
    tagName() {
        return this[_tagName];
    }
}
//# sourceMappingURL=WebDomElement.js.map